'use client'

import ProductCard, { CARD_ASPECT } from "../product/ProductCard"
import Skeleton from "@/components/elements/Skeleton"
import EmptyState from "../elements/EmptyState"
import { panelFocusRing } from "../elements/SidePanel"
import { HeartOff } from 'lucide-react'
import { navigateUrl } from "@/utils/client-request"
import { usePathname } from "next/navigation"

const gridClass = 'grid grid-cols-2 lg:grid-cols-4 gap-x-1 gap-y-8 lg:gap-y-12'

export default function Wishlist({ wishlist, vendor }: { wishlist: any, vendor: any }) {
  const pathname = usePathname()

  if (wishlist === undefined || wishlist === null) return <WishlistSkeleton />

  const products = wishlist.products || []

  return (
    <div>
      <div className="flex items-end justify-between gap-4 pb-6 mb-8 border-b border-border">
        <div className="min-w-0">
          <h1 className="text-2xl sm:text-3xl tracking-tight text-foreground">Хүслийн жагсаалт</h1>
          <p className="mt-2 text-sm text-muted-foreground">Таны хүслийн жагсаалтад нэмсэн бүтээгдэхүүнүүд</p>
        </div>
        {products.length > 0 && <span className="shrink-0 text-[13px] text-muted-foreground tabular-nums">{products.length} бүтээгдэхүүн</span>}
      </div>

      {products.length > 0 ? (
        <div className={gridClass}>
          {products.map((product: any, index: number) => (
            <ProductCard key={`${product.id}-${product.variant?.id || `wishlist-${index}`}`} product={product} vendor={vendor} showVariantName />
          ))}
        </div>
      ) : (
        <EmptyState icon={HeartOff} title="Хүслийн жагсаалт хоосон байна" description="Таны жагсаалтад нэмсэн бараа энд харагдах болно.">
          <a href={navigateUrl('/product', pathname)} className={`inline-flex items-center h-11 px-8 border border-foreground text-[13px] tracking-wide transition-colors duration-150 hover:bg-foreground hover:text-background ${panelFocusRing}`}>Дэлгүүр хэсэх</a>
        </EmptyState>
      )}
    </div>
  )
}

function WishlistSkeleton() {
  return (
    <div>
      <div className="pb-6 mb-8 border-b border-border space-y-2">
        <Skeleton className="w-48 h-8 rounded-none" />
        <Skeleton className="w-72 max-w-full h-4 rounded-none" />
      </div>
      <div className={gridClass}>
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i}>
            <Skeleton className={`w-full ${CARD_ASPECT} rounded-none`} />
            <Skeleton className="w-3/4 h-3.5 mt-3 rounded-none" />
            <Skeleton className="w-1/3 h-3.5 mt-2 rounded-none" />
          </div>
        ))}
      </div>
    </div>
  )
}
